<div class="overLayDiv active"></div>
<div id="rightSideBar" *ngIf="!fmSpecialObject">
    <div class="rightSidePanel d-flex flex-column" style="z-index: 99999;">
        <header class="panel-header">
            <div class="viewDemo title-and-video">
                <h2>{{'text_select_cost_centre' | translate:param}}</h2>
            </div>
            <div class="panel-left-btn">
               
                <button type="button" class="btn eod-btn-primary height-38px mr-2" (click)="fnSelectCostCentre()"
                    [ngClass]="{ 'disabled': !this.hasFormChanges || disableSave}">
                    {{ 'label_save' | translate: param }}
                </button>
                <button type="button" class="btn eod-btn-outline-warning height-38px" (click)="fnClosePanel()">
                    {{ 'label_close' | translate }}
                </button>
            </div>
        </header>
        
        <div class="row">
            <div class="col-md-12 col-sm-12 col-lg-12 col-xl-12 margin-top-10 no-padding-right-left">
                <div class="block padding-top-0 ">
                    <div class="row margin-top-25">
                        <div class="col-lg-6 padding-left-0">
                            <div class="input-group">
                                <input type="text" class="form-control searchField" #searchField
                                    [ngClass]="{ 'has-value': searchField.value }" name="searchText"
                                    [(ngModel)]="searchText" autocomplete="off">
                                <label for="ExpenseCategory">{{ "label_search_criterion" | translate: param }}</label>
                                <span class="icons"><a>
                                        <i class="fas fa-search" aria-hidden="true"></i>
                                    </a>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="block heightCalc-12 overflow-auto scrollbar-visible">
                    <div class="row">
                        <div class="col-lg-12 no-padding-right-left">
                            <h6 class="note border-bottom padding-bottom-10">{{'text_select_cost_centre' | translate:param}}
                            </h6>

                            <div class="text-center noDataAvailable disabled opacity-60"
                                *ngIf="(costCentreList | grdFilter : {derivedName: searchText}).length === 0">
                                {{ "no_data_available" | translate: param }}
                            </div>

                            <ul class="exportReportWrite-exportFile"
                                *ngIf="(costCentreList | grdFilter : {derivedName: searchText}).length>0">
                                <li class="border-bottom padding-bottom-0 lH-40">
                                    <div id="accordion"
                                        *ngFor="let item of costCentreList | grdFilter: { derivedName: searchText}"
                                        (click)="fnOnChangeCostCentre(item.costCentreId);hasFormChanges = true;">
                                        <div class="card "
                                            [ngClass]="(costCentreList.length > 1)? 'margin-top-10':'margin-top-0'">
                                            <div class="card-header text-ellipsis cursor-pointer px-3 px-3 py-2 min-h-4em d-flex align-items-center"
                                                [ngClass]="item.isHomeCostCentre ? 'py-1':'py-2'">
                                                <span class="card-link d-flex align-items-top lh-lg" data-bs-toggle="collapse"
                                                    data-bs-target="#collapseOne">
                                                    <input type="checkbox" class="mt-2 svg-15" (change)="hasFormChanges = true;"
                                                        [checked]="item.costCentreId ==selectedCostCentreId">
                                                    <div div class="d-flex flex-column justify-content-start pl-1">
                                                        <span>{{item.derivedName}}</span>
                                                        <small class="d-block lh-sm mb-1"
                                                            *ngIf="item.isHomeCostCentre">
                                                            {{'home_cost_centre' | translate:param}}
                                                        </small>
                                                    </div>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div id="rightSideBar" *ngIf="fmSpecialObject">
    <div class="rightSidePanel active" >
        <header class="panel-header">
            <div class="viewDemo title-and-video">
                <h2>{{'text_select_cost_centre' | translate:param}}</h2>
            </div>            
            <div class="panel-left-btn" >
                 <button type="button" class="btn eod-btn-outline-warning height-38px mr-2" (click)="fnOpenMaintainCostCentres()">
                    {{ "maintain_cost_centres" | translate }}
                </button>
                 <button type="button" class="btn eod-btn-primary height-38px mr-2" (click)="fnAddCostCentre()">
                    {{ "add_cost_centre" | translate }}
                </button>
                 <button type="button" class="btn eod-btn-primary height-38px mr-2" (click)="fnSelectCostCentre()"
                    [ngClass]="{ 'disabled': !this.hasFormChanges || disableSave}">
                    {{ 'label_save' | translate: param }}
                </button>
                <button type="button" class="btn eod-btn-outline-warning" (click)="fnClosePanel()">
                    {{ 'label_close' | translate }}
                </button>
            </div>
        </header>
        <div class="row">
            <div class="col-md-12 col-sm-12 col-lg-12 col-xl-12 margin-top-10 no-padding-right-left">
                <div class="block padding-top-0 ">
                    <div class="row margin-top-25">
                        <div class="col-lg-6 padding-left-0">
                            <div class="input-group">
                                <input type="text" class="form-control searchField" #searchField
                                    [ngClass]="{ 'has-value': searchField.value }" name="searchText"
                                    [(ngModel)]="searchText" autocomplete="off">
                                <label for="ExpenseCategory">{{ "label_search_criterion" | translate }}</label>
                                <span class="icons"><a>
                                        <i class="fas fa-search" aria-hidden="true"></i>
                                    </a>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="block padding-top-10 heightCalc-12 overflow-auto scrollbar-visible">
                    <div class="row">
                        <div class="col-lg-12 no-padding-right-left">

                            <div class="text-center noDataAvailable disabled opacity-60"
                                *ngIf="(costCentreList | grdFilter : {derivedName: searchText}).length === 0">
                                {{ "no_data_available" | translate: param }}
                            </div>

                            <ul class="bulkList">
                                <li class="border-bottom padding-bottom-12  f-14 "
                                    *ngFor="let item of costCentreList | grdFilter: { derivedName: searchText}"
                                    (click)="fnOnChangeCostCentre(item.costCentreId);hasFormChanges = true;"
                                    [ngClass]="{'active': item.costCentreId ==selectedCostCentreId }">
                                    <span class="d-inline-block w-100pc text-ellipsis">{{item.derivedName}}</span>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<app-action-panel [(model)]="actionPanelModel" [config]="actionPanelConfig"
  (onSubmitPanel)="onActionPanelSubmit($event)" [hideActionButtons]="hideActionButtons">
</app-action-panel>

<app-cost-centre-on-off *ngIf="showCostCentreOnOffPanel" (closePanel)="fnCloseCostCentreOnOffPanel($event)"></app-cost-centre-on-off>
